import React, { useState } from 'react';
import Conference from '../../Conference/conference';
import AgentDashboard from '../../AgentDashboard/AgentDashboard';
import PowerBiDash from '../../../Reports/powerBi/powerBiDash';
import ProductToolkits from '../../Product-Toolkits/product-toolkits';
import QuickLinks from '../../Quick-Links/quick-links';
import { useUser } from 'context/UserContext';
import './Home.scss';
import SelectProducer from '../../../Reports/selectProducer/selectProducer';
import SfuSnackbarNotification from '../../../Software/Subpages/SecureFileDelivery/SfuSnackbarNotification';

function Home() {
  const user = useUser();
  const [powerBiUpdateInfo, setPowerBiUpdateInfo] = useState(null);
  return (
    <div className="Home">
      <div className="HomeContainer">
        <div className="HomeHero">
          <div className="HomeDashboard">
            {/*user.permissions.Reporting && <p className="HomeDashboardHeader">Dashboard</p>*/}
            <div className="HomeDashboardContainer">
              {/*user.permissions.Reporting &&
                                <AgentDashboard />   
                            */}
              {user.permissions.Convention && (
                <div className="HomeBanner">
                  <Conference />
                </div>
              )}
              <div className="QuickLinksContainer">
                <p className="QuickLinksHeader">Quick Links</p>
                <QuickLinks />
              </div>
              <div className="MobileQuickLinksContainer">
                <p className="QuickLinksHeader">Quick Links</p>
                <QuickLinks />
              </div>
              <hr />
              {user.permissions.Reporting && ( //only show the dashboard if we have reporting permissions
                <>
                  <SelectProducer
                    setNpnUpdateDetails={setPowerBiUpdateInfo}
                    useLabel={true}
                    useIcon={true}
                    selectBackgroundColor={'rgb(115, 147, 179)'}
                    textColor="white"
                    variant="outlined"
                    selectSx={{
                      '& .MuiOutlinedInput-input': {
                        padding: '.4rem .6rem',
                        fontWeight: 'bold',
                        fontSize: '.875rem',
                      },
                    }}
                  />
                  <PowerBiDash powerBiUpdateDetails={powerBiUpdateInfo} />
                </>
              )}
            </div>
          </div>

          <div className="MobileProductToolkitsContainer">
            <p className="ProductToolkitsHeader">Product Toolkits</p>
            <ProductToolkits />
          </div>
        </div>
        <div className="ProductToolkitsContainer">
          {/*<p className="ProductToolkitsHeader">Product Toolkits</p>*/}
          <ProductToolkits />
        </div>
        <SfuSnackbarNotification />
      </div>
    </div>
  );
}

export { Home };

// {"https://app.powerbi.com/groups/4fdd8a90-d82a-40d6-a97c-1e55b0ff0b13/dashboards/0bc87d21-0388-4a3b-a25b-4b368aa4c8d2?experience=power-bi"}
